
document.addEventListener("DOMContentLoaded", function () {

    // Toggle filter list display on filter text click
    document.querySelector(".block__quote-filtertxt").addEventListener("click", function () {
        const filterList = document.querySelector(".block__quote-filterlist");
        filterList.style.display = (filterList.style.display === "block") ? "none" : "block";
    });
    const allOptions = document.querySelectorAll(".block__quote-filterlist .block__quote-filter-item");
    // Attach click event to each filter item
    document.querySelector(".block__quote-filterlist").addEventListener("click", function (e) {
      if (e.target && e.target.classList.contains("block__quote-filter-item")) {
          const selectedQuoteItem = e.target.getAttribute("data-value");
          const allOptions = document.querySelectorAll(".block__quote-filter-item");
          allOptions.forEach(option => option.classList.remove("selected"));
          e.target.classList.add("selected");

          document.querySelector(".block__quote-filtertxt .filter-txt").innerHTML = e.target.innerHTML;
          this.style.display = "none";

          const allQuoteBlocks = document.querySelectorAll('.block__quote-ordercontentwrap');
          let visibleCount = 0;

          if (selectedQuoteItem === 'all-quotes') {
              allQuoteBlocks.forEach(block => {
                  if (block.classList.contains('available-quote')) {
                      block.style.display = 'block';
                      visibleCount++;
                  } else {
                      block.style.display = 'none';
                  }
              });
          } else {
              allQuoteBlocks.forEach(block => {
                  const quoteFilter = block.getAttribute('data-quotefilter');
                  if (quoteFilter !== selectedQuoteItem) {
                      block.style.display = 'none';
                  } else if (block.querySelector('.main_account_quotehistory')) {
                      block.style.display = 'block';
                      visibleCount++;
                  } else {
                      block.style.display = 'none';
                  }
              });
          }

          // Show or hide empty message
          const emptyMsg = document.querySelector(".block__quote-empty-message");
          if (emptyMsg) {
              emptyMsg.style.display = (visibleCount === 0) ? 'block' : 'none';
          }
      }
    });

  
    let uniquedraftid = [...new Set(customerOrderQuoteId)];
    let cid = document.querySelector(".block_main_account-section").getAttribute('data-customerid');
    fetch('https://app.kiefer.com/draftorderlist_by_customerid.php', {
        method: 'POST', 
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            customerid: cid
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log("Response Data:", data);
        if (!data.message || data.message.length === 0) {
            // Show empty quote message
            document.querySelector('.block__quote__emptycontent')?.remove();
            document.querySelector('.quote-content-loader .loading__spinner')?.classList.add('hidden');

            const container = document.querySelector('.main_account_quotetab-content');
            if (container) {
                container.insertAdjacentHTML('afterbegin', `
                    <div class="block__quote__emptycontent">
                        <h2 class="empty-quote block__content-heading block__tabcontent-heading">Quote is empty.</h2>
                        <div class="block__quoteempty-btn">
                            <a href="/" class="button--secondary inline-block custom_btn black_btn" style="padding: 10px 15px;">Continue Shopping</a>
                        </div>
                    </div>
                `);
            }
            return; // Exit the .then block early
        }
        data.message.forEach((order, index) => {
            if (uniquedraftid.includes(order.name)) {
                QuoteorderData(order, index);
            } else {
              if (order.days) {
                  const today = new Date().toISOString().split('T')[0];
                  const start = new Date(order.days);
                  const daysDiff = Math.ceil((new Date(today) - start) / (1000 * 60 * 60 * 24));

                  // Clean up tags
                  let quotetags = order.tags || '';
                  quotetags = quotetags.replace(/Issued|Open|Submitted|Unissued|Accepted|issued|open|submitted|unissued|accepted/g, '').trim();
                  quotetags = quotetags.replace(/,\s*,/g, ', ').replace(/^\s*,|,\s*$/g, '').trim();
                  quotetags += ", Closed";

                  if (daysDiff >= 90) {
                      let draftOrderid = order.id;
                      fetch('https://app.kiefer.com/delete_draft_order.php', {
                          method: 'POST',
                          headers: {
                          'Content-Type': 'application/x-www-form-urlencoded'
                          },
                          body: new URLSearchParams({
                              draft_order_id: draftOrderid,
                              newtag: quotetags
                          })
                      }).catch(error => {
                          // Optionally log the error
                          // console.error("Delete error:", error);
                      });
                  }
              }
              let current_drafttag = order.tags || '';
                if(current_drafttag.indexOf('Void') != -1 || current_drafttag.indexOf('void') != -1){               
                } else{
                  QuoteorderData(order, index);
                }
            }
        });
    })
    .catch(error => {
        console.log("block__quote__emptycontent",error)
        document.querySelector('.block__quote__emptycontent')?.remove();
        document.querySelector('.quote-content-loader .loading__spinner')?.classList.add('hidden');
        const container = document.querySelector('.main_account_quotetab-content');
        if (container) {
            container.insertAdjacentHTML('afterbegin', `
            <div class="block__quote__emptycontent">
                <h2 class="empty-quote block__content-heading block__tabcontent-heading">Quote is empty.</h2>
                <div class="block__quoteempty-btn">
                <a href="/pages/shop-by-category" class="custom_btn black_btn">Continue Shopping</a>
                </div>
            </div>
            `);
        }
    });  
    
    function QuoteorderData(order, index) {
        let ordersHtml = '';
        let orderdate = new Date(order.created_at);
        let order_tag = order.tags;
        let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formattedDate = `${monthNames[orderdate.getMonth()]} ${orderdate.getDate().toString().padStart(2, '0')}, ${orderdate.getFullYear()}`;

        // quote activate date difference
        let quote_daysDiff = 0;
        let quote_activetoday = new Date().toISOString().split('T')[0];
        if (order.days) {
            let quote_activestart = new Date(order.days);
            quote_daysDiff = Math.ceil((new Date(quote_activetoday) - quote_activestart) / (1000 * 60 * 60 * 24));
        }

        let main_first_quoteindex = '',
        order_item_variantid = '',
        order_invoicefile = '';
        if (index == 0) {
        main_first_quoteindex = 'is-open';
      } else {} 
      if(order_tag.indexOf('Issued') != -1 || order_tag.indexOf('issued') != -1 || order_tag.indexOf('Accepted') != -1 || order_tag.indexOf('accepted') != -1 || order_tag.indexOf('completed') != -1 || order_tag.indexOf('Open') != -1 || order_tag.indexOf('open') != -1){
        if (order.total_price <= 0) {
          ordersHtml += '<div class="main_account_quotehistory ' + main_first_quoteindex + '" style="display:none;">';
        } else {
          ordersHtml += '<div class="main_account_quotehistory ' + main_first_quoteindex + '">';
        }
      }else{
        ordersHtml += '<div class="main_account_quotehistory ' + main_first_quoteindex + '">';
      }
      ordersHtml += '<div class="main_account_quotecontent-head flex gap-10 items-center justify-between">';
      ordersHtml += '<div class="main_account-lefthead-quotecontent flex gap-10 items-center  main_account_quotepadding">';
      ordersHtml += '<div class="main_account_quotenumber large_body font-weight-300">Quote ID : <strong class="font-weight-400">' + order.name + '</strong></div>';
      ordersHtml += '<span class="main_account_quotedate small_body font-weight-400 opacity-0-7"><time datetime="' + order.created_at + '">' + formattedDate + '</time></span>';
      if(order.order_invoice_file){
        order_invoicefile = order.order_invoice_file
        ordersHtml += '<div class="main_account-invoicefile">';
        ordersHtml += '<a href="'+order_invoicefile.replace("https://cdn.shopify.com/s/files/1/0649/5410/6050/files")+'" class="main_account_invoice_download extra_small_body13" download="Invoice_file">';
        ordersHtml += '<span class="account_download_icon"><svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">';
        ordersHtml += '<path d="M6.32422 11.8438L1.82422 7.34375C1.61589 7.11458 1.61589 6.88542 1.82422 6.65625C2.05339 6.44792 2.28255 6.44792 2.51172 6.65625L6.16797 10.2812V1C6.1888 0.6875 6.35547 0.520833 6.66797 0.5C6.98047 0.520833 7.14714 0.6875 7.16797 1V10.2812L10.8242 6.65625C11.0534 6.44792 11.2826 6.44792 11.5117 6.65625C11.7201 6.88542 11.7201 7.11458 11.5117 7.34375L7.01172 11.8438C6.90755 11.9479 6.79297 12 6.66797 12C6.54297 12 6.42839 11.9479 6.32422 11.8438ZM12.168 13.5C12.4805 13.5208 12.6471 13.6875 12.668 14C12.6471 14.3125 12.4805 14.4792 12.168 14.5H1.16797C0.855469 14.4792 0.688802 14.3125 0.667969 14C0.688802 13.6875 0.855469 13.5208 1.16797 13.5H12.168Z" fill="currentColor"></path></svg></span>';
        ordersHtml += 'Invoice</a></div>';
      }else{}
      
      ordersHtml += '</div>';
      ordersHtml += '<div class="main_account-righthead-quotecontent flex items-center">';
      ordersHtml += '<div class="main_account-quotetotal font-weight-600 primary_h4 main_account_quotepadding">Total : <strong class="font-weight-600">'+ currency_symbol + order.total_price+ '</strong></div>';
      ordersHtml += '<div class="main_account-managequote flex items-center main_account_quotepadding"><a href="'+order.invoice_url+'" class="button--secondary text-capitalize font-weight-500 placeorder_btn" bis_skin_checked="1">Place Order</a>';
      if(order_tag.includes("Won") || order_tag.includes("won")){
        ordersHtml += '<div class="custom_btn blue_btn">Order Completed</div>';
      }
    
      ordersHtml += '<a href="javascript:void(0);" class="button--secondary text-capitalize font-weight-500 resubmitted_btn" data-draft-order-id="'+order.id+'">Re-submit</a><div class="quote_order_cancle" data-draft-order-id="'+order.id+'" title="Cancle your current quote"> </div><span class="main_account-managequote-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none"><path d="M1 1L7 7L13 1" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span></div>';
      ordersHtml += '</div>';
      ordersHtml += '</div>';
      ordersHtml += '<div class="main_account_quotecontent-body">';
     
      if (!order_tag.includes("Submitted") || !order_tag.includes("submitted") && !order_tag.includes("Unissued") || !order_tag.includes("unissued") && !order_tag.includes("Accepted") || !order_tag.includes("accepted") && !order_tag.includes("Issued") || !order_tag.includes("issued") && !order_tag.includes("Open") || !order_tag.includes("open")) {
     
        ordersHtml += '<form id="quoteproduct-listform" class="hidden-customerinfo flex flex-direction-column gap-15">';
        ordersHtml += '<input type="hidden" name="tags" value="Unissued"><input type="hidden" name="salesperson" value="Salesperson:' + customer_firstname + '"><input type="hidden" class="form-control" name="customerName" value="'+customer_firstname+'">';
        ordersHtml += '<input type="hidden" class="form-control" name="customerEmail" value="'+customer_email+'"><input type="hidden" class="form-control" name="customerCountry" value="'+customer_country+'"><input type="hidden" class="form-control" name="customerZipcode" value="'+customer_zipcode+'">';
        ordersHtml += '<input type="hidden" class="form-control" name="customerPhoneNumber" value="'+customer_phone+'"><input type="hidden" class="form-control" name="days" value=""><input type="hidden" class="form-control" name="customerNotes" value=""><input type="hidden"  class="form-control" name="fileimage[]" multiple>';
   
      }else{
        if(quote_daysDiff >= 90){
          ordersHtml += '<form id="quoteproduct-listform" class="hidden-customerinfo flex flex-direction-column gap-15">';
          ordersHtml += '<input type="hidden" name="tags" value="Unissued"><input type="hidden" name="salesperson" value="Salesperson:' + customer_firstname + '"><input type="hidden" class="form-control" name="customerName" value="'+customer_firstname+'">';
          ordersHtml += '<input type="hidden" class="form-control" name="customerEmail" value="'+customer_email+'"><input type="hidden" class="form-control" name="customerCountry" value="'+customer_country+'"><input type="hidden" class="form-control" name="customerZipcode" value="'+customer_zipcode+'">';
          ordersHtml += '<input type="hidden" class="form-control" name="customerPhoneNumber" value="'+customer_phone+'"><input type="hidden" class="form-control" name="days" value=""><input type="hidden" class="form-control" name="customerNotes" value=""><input type="hidden"  class="form-control" name="fileimage[]" multiple>';
        }else{
          ordersHtml += '';
        }
      }
      order.line_items.forEach(function(item) {
        ordersHtml += '<div class="main_account_quoteitem secondary-border-radius flex items-center justify-between gap-10"><input type="hidden" name="quotealltag" value="'+order.tags+'" />';
        let variantid= item.variant_id;
        order_item_variantid = variantid.match(/\d+$/)[0];
        if(quote_daysDiff < 90){
          if(order_tag.indexOf('Submitted') != -1 || order_tag.indexOf('Submitted') != -1 || order_tag.indexOf('Unissued') != -1 || order_tag.indexOf('unissued') != -1){
            ordersHtml += '<input type="hidden" name="quotedraftid" value="'+order.name+'"/><input type="hidden" name="quotevariant" value="'+item.variant_id+'"/><input type="hidden" name="quoteqty" value="'+item.product_quantity+'"/>';
            ordersHtml += '<input type="hidden" class="newtag" name="newtag" value="">';
          }else if(order_tag.indexOf('Accepted') != -1 || order_tag.indexOf('accepted') != -1 || order_tag.indexOf('completed') != -1 || order_tag.indexOf('Issued') != -1 || order_tag.indexOf('issued') != -1 || order_tag.indexOf('Open') != -1 || order_tag.indexOf('open') != -1){
            ordersHtml += '<input type="hidden" name="quotedraftid" value="'+order.name+'"/><input type="hidden" name="quotevariant" value="'+item.variant_id+'"/><input type="hidden" name="quoteqty" value="'+item.product_quantity+'"/>';
            ordersHtml += '<input type="hidden" class="newtag" name="newtag" value="">';
          }else{
            ordersHtml += '<input type="hidden" name="variantId[]" value="'+order_item_variantid+'"/><input type="hidden" name="quantity[]" value="'+item.product_quantity+'"/>';
            ordersHtml += '<input type="hidden" name="p_title[]" value="'+item.product_title+'"/><input type="hidden" name="p_price[]" value="'+item.product_price+'"/>';
          }
        }else{
          ordersHtml += '<input type="hidden" name="variantId[]" value="'+order_item_variantid+'"/><input type="hidden" name="quantity[]" value="'+item.product_quantity+'"/>';
          ordersHtml += '<input type="hidden" name="p_title[]" value="'+item.product_title+'"/><input type="hidden" name="p_price[]" value="'+item.product_price+'"/>';
        }

        ordersHtml += '<div class="main_account_quoteitem-img-con-wrap flex items-center gap-15">';

        // Product image
        ordersHtml += '<div class="main_account_quoteitem-imgwrap line-height primary-border-radius">';
        if (item.product_image_src == undefined || item.product_image_src == null || item.product_image_src == '') {
          ordersHtml += 'No Image';
        } else {
          ordersHtml += '<img src="' + item.product_image_src + '" alt="Quote item" class="primary-border-radius" width="" height="">';
        }
        ordersHtml += '</div>';

        // Product details
        ordersHtml += '<div class="main_account_quoteitem-titlecontent flex gap-10 flex-direction-column">';
        ordersHtml += '<div class="main_account_quoteitem-title font-weight-500 medium_body"><a href="/products/' + item.product_handle + '" class="main_account_quoteitem-titlelink">' + item.product_title + '</a></div>';
        if(item.variant_title!=null && item.variant_title!=''){
        ordersHtml += '<div class="main_account_quoteitem-vaiant_title medium_body"><span class="font-weight-500">Color/Size :</span> <span class="opacity-0-6">' + item.variant_title + '</span></div>';
        }
        // Mobile content
        ordersHtml += '<div class="main_account_quoteitem-mobilecontent">';
        ordersHtml += '<div class="main_account__quoteitem-qtycontent medium_body"><span class="main_account__quoteitem-qty"><span class="opacity-0-6">Qty :</span> <strong>' + item.product_quantity + '</strong></span></div>';
        ordersHtml += '<div class="main_account__quoteitem-pricecontent medium_body"><span class="main_account__quoteitem-price"><span class="opacity-0-6">Quoted Price (each):</span> <strong>' + currency_symbol + item.product_price + '</strong></span></div>';
        let mobileTotal = item.product_quantity * item.product_price;
        ordersHtml += '<div class="main_account__quoteitem-total medium_body"><span class="main_account__quoteitem-total"><span class="opacity-0-6">Total Price :</span> <strong>' + currency_symbol + mobileTotal + '</strong></span></div>';
        ordersHtml += '</div>'; // close mobile content
        ordersHtml += '</div>'; // close titlecontent
        ordersHtml += '</div>'; // close img-con-wrap

        // Desktop content (Qty + Price in one wrapper)
        ordersHtml += '<div class="main_account_quoteitem-content flex items-center">';

        // Qty block
        ordersHtml += '<div class="main_account__quoteitem-qtycontent medium_body">';
        ordersHtml += '<span class="main_account__quoteitem-qty"><span class="opacity-0-6">Qty :</span> <strong>' + item.product_quantity + '</strong></span>';
        ordersHtml += '</div>';

        // Prices wrapper
        ordersHtml += '<div class="main_account_quoteitem-pricewrap flex gap-5 flex-direction-column">';

        // Quoted price
        ordersHtml += '<div class="main_account__quoteitem-pricecontent medium_body">';
        ordersHtml += '<span class="main_account__quoteitem-price"><span class="opacity-0-6">Quoted Price (each):</span> <strong>' + currency_symbol + item.product_price + '</strong></span>';
        ordersHtml += '</div>';

        // Total price
        let mainPrice = item.product_quantity * item.product_price;
        mainPrice = (Math.ceil(mainPrice * 100) / 100).toFixed(2);
        ordersHtml += '<div class="main_account__quoteitem-total medium_body">';
        ordersHtml += '<span class="main_account__quoteitem-total"><span class="opacity-0-6">Total Price :</span> <strong>' + currency_symbol + mainPrice + '</strong></span>';
        ordersHtml += '</div>';

        ordersHtml += '</div>'; // close pricewrap
        ordersHtml += '</div>'; // close content
        ordersHtml += '</div>'; // close main wrap


        
      });
      if (!order_tag.includes("Submitted") || !order_tag.includes("Submitted") && !order_tag.includes("Unissued") || !order_tag.includes("unissued") && !order_tag.includes("Accepted") || !order_tag.includes("accepted") && !order_tag.includes("Issued") || !order_tag.includes("issued") && !order_tag.includes("Open") || !order_tag.includes("open")) {
        ordersHtml += '</form>';
      }else{
        if(quote_daysDiff >= 90){
          ordersHtml += '</form>';
        }else{
          ordersHtml += '';
        }
      }
      ordersHtml += '<div class="main_account__quoteitem-chatnote flex flex-direction-column gap-5 line-height">';
      if(order.note != '' && order.note!=undefined){
        ordersHtml += '<div class="main_account__quoteitem-quotenote font-weight-500 desktop_mobile_small"><span class="opacity-0-6">Order Notes :</span> <span class="main_account__quoteitem-notetxt">'+ order.note +'</span></div>';
      }else{} 
      ordersHtml += '</div>'; 
      ordersHtml += '</div>';
        ordersHtml += '<div class="main_account-righthead-quotecontent quotecontent_btnbottom flex items-center gap-10 justify-between">';
        ordersHtml += '<div class="main_account-quotetotal font-weight-600 primary_h4 main_account_quotepadding">Total : <strong class="font-weight-600">'+ currency_symbol + order.total_price+ '</strong></div>';
        ordersHtml += '<div class="main_account-managequote flex items-center main_account_quotepadding"><a href="'+order.invoice_url+'" class="button--secondary text-capitalize font-weight-500 placeorder_btn" bis_skin_checked="1">Place Order</a>';
        if(order_tag.includes("Won") || order_tag.includes("won")){
          ordersHtml += '<div class="custom_btn blue_btn">Order Completed</div>';
        }
        ordersHtml += '<a href="javascript:void(0);" class="button--secondary text-capitalize font-weight-500 resubmitted_btn" data-draft-order-id="'+order.id+'">Re-submit</a><div class="quote_order_cancle" data-draft-order-id="'+order.id+'" title="Cancle your current quote"> </div></div>';
        ordersHtml += '</div>';
        ordersHtml += '</div>';
      ordersHtml += '</div>';
      
      
        document.querySelector('.quote-content-loader .loading__spinner')?.classList.add('hidden');
        document.querySelector('.block__quote-order-filterwrap')?.style.setProperty('display', 'flex');        

      
        if(quote_daysDiff < 30){
          if(order_tag.indexOf('Won') == -1){
            if(order_tag.indexOf('Submitted') != -1 || order_tag.indexOf('submitted') != -1 || order_tag.indexOf('Unissued') != -1 || order_tag.indexOf('unissued') != -1){
              const submittedContainer = document.querySelector('#quote-submitted-container');
              const submittedWrapper = submittedContainer?.closest('.block__quote-ordercontentwrap');
              if (submittedWrapper) {
                submittedWrapper.classList.add('available-quote');
                submittedWrapper.style.setProperty('display', 'block');
              }
              if (submittedContainer) {
                submittedContainer.insertAdjacentHTML('beforeend', ordersHtml);
              }
            }else if(order_tag.indexOf('Active') != -1 || order_tag.indexOf('active') != -1 || order_tag.indexOf('completed') != -1 || order_tag.indexOf('Issued') != -1 || order_tag.indexOf('issued') != -1 || order_tag.indexOf('Open') != -1 || order_tag.indexOf('open') != -1){
              const activatedContainer = document.querySelector('#quote-activated-container');
              if (activatedContainer) {
                const wrapper = activatedContainer.closest('.block__quote-ordercontentwrap');
                if (wrapper) {
                  wrapper.classList.add('available-quote');
                  wrapper.style.display = 'block';
                }
                activatedContainer.insertAdjacentHTML('beforeend', ordersHtml);              
                const firstQuote = activatedContainer.querySelector('.main_account_quotehistory');
                if (firstQuote) {
                  firstQuote.classList.add('is-open');
                }
              }

            }else{
              const closedContainer1 = document.querySelector('#quote-closed-container');
              if (closedContainer1) {
                const wrapper = closedContainer1.closest('.block__quote-ordercontentwrap');
                if (wrapper) {
                  wrapper.classList.add('available-quote');
                  wrapper.style.display = 'block';
                }
                closedContainer1.insertAdjacentHTML('beforeend', ordersHtml);
              }
              
            }
          }
          else{
            const closedContainer2 = document.querySelector('#quote-closed-container');
              if (closedContainer2) {
                const wrapper = closedContainer2.closest('.block__quote-ordercontentwrap');
                if (wrapper) {
                  wrapper.classList.add('available-quote');
                  wrapper.style.display = 'block';
                }
                closedContainer2.insertAdjacentHTML('beforeend', ordersHtml);
              }
          }
        }else{
            const closedContainer3 = document.querySelector('#quote-closed-container');
            if (closedContainer3) {
              const wrapper = closedContainer3.closest('.block__quote-ordercontentwrap');
              if (wrapper) {
                wrapper.classList.add('available-quote');
                wrapper.style.display = 'block';
              }
              closedContainer3.insertAdjacentHTML('beforeend', ordersHtml);
            }
        }
      }

      // RE Sumit Quote
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('resubmitted_btn')) {
        e.preventDefault();

        const btn = e.target;
        btn.classList.add('btn-loading');

        const parentElement = btn.closest('.main_account_quotehistory');
        const formElement = parentElement.querySelector('#quoteproduct-listform');

        if (!formElement) return;

        // Serialize form data
        const formData = new FormData(formElement);

        fetch('https://app.kiefer.com/graphql/draftorder-create.php', {
          method: 'POST',
          body: formData
        })
          .then((response) => response.json())
          .then((line_item) => {
            formElement.classList.add('quote-products-hide');
            formElement.style.display = 'none';

            const heading = document.querySelector('.quotedrawer-product-mainheading');
            if (heading) heading.style.display = 'none';

            const submittedContent = document.querySelector('.quotedrawer-product-submittedcontent');
            if (submittedContent) {
              submittedContent.classList.add('quote-submit-active');
              submittedContent.style.display = 'block';
            }

            localStorage.removeItem('quoteProduct');
            window.location.reload();
          })
          .catch((error) => {
            console.error('Submission error:', error);
          });
      }
    });

    // Cancel draft order
    document.addEventListener('click', function (e) {
        if (e.target.closest('.quote_order_cancle')) {
            e.preventDefault();
            const button = e.target.closest('.quote_order_cancle');
            button.classList.add('cancle-loading');

            const quoteHistory = button.closest('.main_account_quotehistory');
            const draftOrderId = button.dataset.draftOrderId;
            const tagInput = quoteHistory.querySelector('.main_account_quoteitem input[name="quotealltag"]');
            let cancelTags = tagInput?.value || '';

            cancelTags = cancelTags.replace(/Issued|Open|Submitted|Unissued|Accepted/gi, '').trim();
            cancelTags = cancelTags.replace(/,\s*,/g, ',').replace(/^\s*,|,\s*$/g, '').trim();
            cancelTags = cancelTags ? `${cancelTags}, Closed` : 'Closed';

            const payload = new URLSearchParams();
            payload.append('draft_order_id', draftOrderId);
            payload.append('newtag', cancelTags);

            fetch('https://app.kiefer.com/delete_draft_order.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: payload.toString()
            })
            .then(response => response.text())
            .then(data => {
                const result = JSON.parse(data);
                if (result.status === 'success') {
                    button.classList.remove('cancle-loading');
                    window.location.reload();
                } else {
                    button.classList.remove('cancle-loading');
                }
            })
            .catch(err => {
                console.error('Cancel Error:', err);
                button.classList.remove('cancle-loading');
            });
        }
    });
    // Toggle quote section open/close
    document.addEventListener('click', function (e) {
        const arrow = e.target.closest('.main_account-managequote .main_account-managequote-arrow');
        if (arrow) {
            e.preventDefault();
            const quoteHistory = arrow.closest('.main_account_quotehistory');
            quoteHistory.classList.toggle('is-open');
        }
    });
});
